<div class="sidebar">
  <div class="logo">
    <div class="simple-text logo-mini">
      <a
        mat-button
        (click)="toggleSidebar()"
        href="javascript:void(0)"
      >
        <i class="material-icons">menu</i>
      </a>
    </div>
    @if (!sidebarMinimized) {
      <div class="simple-text ms-3 me-2">
        {{ 'general.app_name' | translate }}
      </div>
    }
  </div>
  <div class="logo text-center p-0">
    <div class="simple-text">
      <img
        class="logo-img"
        [class.small-logo-img]="sidebarMinimized"
        [src]="logo()"
        alt=""
      />
    </div>
  </div>
  <div class="sidebar-wrapper">
    <div class="user">
      <div class="user-info">
        <a
          class="user-info-container"
          data-bs-target="#collapseDetails"
          data-bs-toggle="collapse"
        >
          <img
            class="photo"
            [src]="loggedUserImage()"
            [attr.aria-label]="'general.user_image' | translate"
          />

          <span class="username">
            <span>
              {{ loggedUser()?.name }}
            </span>
            <span>
              {{ loggedUser()?.firstName }}
            </span>
          </span>

          <!-- Spacer used to place the arrow to the right -->
          <span class="flex-grow-1"></span>
          <mat-icon>chevron_right</mat-icon>
        </a>

        <div
          class="collapse"
          id="collapseDetails"
        >
          <ul class="nav">
            @if (canEditProfile) {
              <li
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="nav-item"
              >
                <a
                  [routerLink]="['/user/profile']"
                  class="nav-link"
                  [matTooltip]="'users.profile' | translate"
                  matTooltipPosition="right"
                  [matTooltipShowDelay]="300"
                  [matTooltipDisabled]="isNavTooltipDisabled"
                >
                  <span class="sidebar-mini"><i class="material-icons sidebar-mini-icons">portrait</i></span>
                  <span class="sidebar-normal">{{ 'users.profile' | translate }}</span>
                </a>
              </li>
            }
            @if (canEditProfile && !isSuperTenant) {
              <li
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                class="nav-item"
              >
                <a
                  [routerLink]="['/user/notifications']"
                  class="nav-link"
                  [matTooltip]="'general.notifications' | translate"
                  matTooltipPosition="right"
                  [matTooltipShowDelay]="300"
                  [matTooltipDisabled]="isNavTooltipDisabled"
                >
                  <span class="sidebar-mini"><i class="material-icons sidebar-mini-icons">email</i></span>
                  <span class="sidebar-normal">{{ 'general.notifications' | translate }}</span>
                </a>
              </li>
            }
            <li
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-item"
            >
              <a
                href="javascript:void(0)"
                (click)="logout()"
                class="nav-link"
                [matTooltip]="'authentication.sign_out' | translate"
                matTooltipPosition="right"
                [matTooltipShowDelay]="300"
                [matTooltipDisabled]="isNavTooltipDisabled"
              >
                <span class="sidebar-mini"><i class="material-icons sidebar-mini-icons">lock</i></span>
                <span class="sidebar-normal">{{ 'authentication.sign_out' | translate }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ul class="nav nav-content">
      @for (menuItem of menuItems; track menuItem.title) {
        <li
          class="nav-item"
          [class.has-children]="isSidebarCollapseFeatureActive && menuItem.children?.length"
          [routerLinkActive]="!(isSidebarCollapseFeatureActive && menuItem.children) ? 'active' : ''"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          @if (!(isSidebarCollapseFeatureActive && menuItem.children)) {
            <a
              [routerLink]="[
                !isSidebarCollapseFeatureActive && menuItem.children?.length
                  ? menuItem.children[0].path
                  : menuItem.path,
              ]"
              class="nav-link"
              [matTooltip]="'general.menu.' + menuItem.title | translate"
              matTooltipPosition="right"
              [matTooltipShowDelay]="300"
              [matTooltipDisabled]="isNavTooltipDisabled"
            >
              <div class="d-flex align-items-center justify-content-between w-100">
                <div class="d-flex align-items-center gap-2">
                  <i class="material-icons">{{ menuItem.icon }}</i>
                  <p class="mb-0">{{ 'general.menu.' + menuItem.title | translate }}</p>
                </div>
                @if (hasDebts && menuItem.path === '/invoices') {
                  <mat-icon
                    class="text-danger warning-icon"
                    [matTooltip]="'users.has_debts' | translate"
                    matTooltipPosition="right"
                    [matTooltipDisabled]="!isNavTooltipDisabled"
                  >
                    warning
                  </mat-icon>
                }
              </div>
            </a>
          }
          @if (isSidebarCollapseFeatureActive && menuItem.children) {
            <a
              href="javascript:void(0)"
              class="nav-link d-flex align-items-center justify-content-between submenu-trigger"
              [attr.aria-expanded]="isMenuOpened(menuItem)"
              [matTooltip]="'general.menu.' + menuItem.title | translate"
              matTooltipPosition="right"
              [matTooltipShowDelay]="300"
              [matTooltipDisabled]="isNavTooltipDisabled"
              (click)="toggleMenu(menuItem.title)"
            >
              <div class="d-flex align-items-center gap-2">
                <i class="material-icons">{{ menuItem.icon }}</i>
                <p class="mb-0">{{ 'general.menu.' + menuItem.title | translate }}</p>
              </div>
              <mat-icon
                class="submenu-arrow"
                [class.opened]="isMenuOpened(menuItem)"
              >
                chevron_right
              </mat-icon>
            </a>
            <ul
              class="nav flex-column ms-3 submenu"
              [class.opened]="isMenuOpened(menuItem)"
              [style.--submenu-items]="menuItem.children.length"
            >
              @for (child of menuItem.children; track child.title; let itemIndex = $index) {
                <li
                  class="nav-item"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [style.--submenu-item-index]="itemIndex"
                >
                  <a
                    [routerLink]="[child.path]"
                    class="nav-link"
                    [attr.aria-label]="sidebarMinimized ? ('general.menu.' + child.title | translate) : null"
                    [matTooltip]="'general.menu.' + child.title | translate"
                    matTooltipPosition="right"
                    [matTooltipShowDelay]="300"
                    [matTooltipDisabled]="isNavTooltipDisabled"
                  >
                    <i class="material-icons sidebar-mini-icons">{{ child.icon }}</i>
                    @if (!sidebarMinimized) {
                      <span class="sidebar-normal">{{ 'general.menu.' + child.title | translate }}</span>
                    }
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }

      @if (isSiteAdmin || isAdmin || canShowHelpSection || isSuperRole) {
        <li
          class="nav-item"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
        >
          <a
            routerLink="/help"
            class="nav-link"
            [matTooltip]="'general.menu.help' | translate"
            matTooltipPosition="right"
            [matTooltipShowDelay]="300"
            [matTooltipDisabled]="isNavTooltipDisabled"
          >
            <div class="d-flex align-items-center justify-content-between w-100">
              <div class="d-flex align-items-center gap-2">
                <i class="material-icons">help</i>
                <p>{{ 'general.menu.help' | translate }}</p>
              </div>
            </div>
          </a>
        </li>
      }
      @if (canShowCertificationAdmin) {
        <li class="nav-item">
          <button
            type="button"
            class="nav-link border-0 bg-transparent"
            [disabled]="isOpeningCertificationAdmin"
            [matTooltip]="'general.menu.certification_admin' | translate"
            matTooltipPosition="right"
            [matTooltipShowDelay]="300"
            [matTooltipDisabled]="isNavTooltipDisabled"
            (click)="openCertificationAdmin()"
          >
            <div class="d-flex align-items-center gap-2">
              <i class="material-icons">verified_user</i>
              <p>{{ 'general.menu.certification_admin' | translate }}</p>
            </div>
          </button>
        </li>
      }
    </ul>
  </div>
</div>
